<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? '' : 'Recolher Menu' }}</span>
                </li>


                <li @click="setComponenteAtivo('EntidadeTabPage', 'ENTIDADES')">
                    <img src="@/assets/icons/menuEntidades.svg" />
                    <span>Entidades</span>
                </li>


                <li @click="setComponenteAtivo('FornecedoresTabPage', 'FORNECEDORES')">
                    <img src="@/assets/icons/menuOffice.svg" />
                    <span>Fornecedores</span>
                </li>


                <li @click="setComponenteAtivo('PessoasTabPage', 'PARTICIPANTES')">
                    <img src="@/assets/icons/menuPessoas.svg" />
                    <span>Participantes</span>
                </li>


                <li @click="setComponenteAtivo('NotasFiscaisEditPage', 'DIGITAÇÃO DE NOTAS')">
                    <img src="@/assets/icons/inbox.svg" />
                    <span>Digitar Notas Fiscais</span>
                </li>


                <li @click="setComponenteAtivo('NotasFiscaisValidacaoTabPage', 'VALIDAÇÃO DE NOTAS')">
                    <img src="@/assets/icons/incognito.svg" />
                    <span>Validação de Notas</span>
                </li>


                <li @click="setComponenteAtivo('CuponsTabPage', 'CUPONS EMITIDOS')">
                    <img src="@/assets/icons/menuTipos.svg" />
                    <span>Consultar Cupons Emitidos</span>
                </li>


                <li @click="setComponenteAtivo('NotasFiscaisTabPage', 'NOTAS FISCAIS')">
                    <img src="@/assets/icons/menuDados.svg" />
                    <span>Consulta de Notas</span>
                </li>


                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.svg" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('CadastrosReportPage', 'CADASTROS')">
                                <span>Cadastros</span>
                            </li>

                            <li @click="selectOption('CuponsReportPage', 'RELATÓRIO DE CUPONS')">
                                <span>Cupons Emitidos</span>
                            </li>

                            <li @click="selectOption('NotasReportPage', 'RELATÓRIO DE NOTAS FISCAIS')">
                                <span>Notas Fiscais Registradas</span>
                            </li>
                        </ul>
                    </div>
                </li>



                <!-- <li @mouseover="showAnalisesMenu = true" @mouseleave="showAnalisesMenu = false">
                    <img src="@/assets/icons/menuMoney.svg" />
                    <span>Análises Econômicas</span>
                    <div v-if="showAnalisesMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('x', 'ANÁLISES ECONÔMICAS NÃO DISPONÍVEIS')">
                                <span>Econômico</span>
                            </li>

                            <li @click="selectOption('x', 'ANÁLISES ECONÔMICAS NÃO DISPONÍVEIS')">
                                <span>ISS</span>
                            </li>

                            <li @click="selectOption('x', 'ANÁLISES ECONÔMICAS NÃO DISPONÍVEIS')">
                                <span>Produtor Rural</span>
                            </li>

                            <li @click="selectOption('x', 'ANÁLISES ECONÔMICAS NÃO DISPONÍVEIS')">
                                <span>Notas por Setor</span>
                            </li>
                        </ul>
                    </div>
                </li> -->


                <li v-if="globalStore.ckadmin==='S'" @click="setComponenteAtivo('ProgramasTabPage', 'PROGRAMAS')">
                    <img src="@/assets/icons/menuOdometer.svg" />
                    <span>Programas</span>
                </li>


                <li v-if="globalStore.ckadmin==='S'" @click="setComponenteAtivo('UsuariosTabPage', 'USUÁRIOS')">
                    <img src="@/assets/icons/menuUsers.svg" />
                    <span>Usuários</span>
                </li>


                <li @click="setComponenteAtivo('UsuarioViewPage', 'USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Meus Dados</span>
                </li>

                
                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'SG-VALORIZA' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ globalStore.nmusuario }}</div>
                        <div class="establishment-name">{{ globalStore.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='CuponsTabPage'"><CuponsTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EntidadeTabPage'"><EntidadeTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FornecedoresTabPage'"><FornecedoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NotasFiscaisEditPage'"><NotasFiscaisEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NotasFiscaisTabPage'"><NotasFiscaisTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NotasFiscaisValidacaoTabPage'"><NotasFiscaisValidacaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PessoasTabPage'"><PessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProgramasTabPage'"><ProgramasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage @close="setComponenteAtivo(null, null)"/></div>


                    <div v-else-if="nmComponenteAtivo=='CadastrosReportPage'"><CadastrosReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='CuponsReportPage'"><CuponsReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NotasReportPage'"><NotasReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else><OperacionalDash /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';
import { globalStore } from '@/globals';


import CuponsTabPage from '../operacional/CuponsTabPage.vue';
import EntidadeTabPage from '../cadastros/tabelas/EntidadeTabPage.vue';
import FornecedoresTabPage from '../cadastros/tabelas/FornecedoresTabPage.vue';
import NotasFiscaisEditPage from '../operacional/NotasFiscaisEditPage.vue';
import NotasFiscaisTabPage from '../operacional/NotasFiscaisTabPage.vue';
import NotasFiscaisValidacaoTabPage from '../operacional/NotasFiscaisValidacaoTabPage.vue';
import OperacionalDash from '../dashboard/OperacionalDash.vue';
import PessoasTabPage from '../cadastros/tabelas/PessoasTabPage.vue';
import ProgramasTabPage from '../cadastros/tabelas/ProgramasTabPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';


// SUBMENU RELATÓRIOS
import CadastrosReportPage from '../reports/CadastrosReportPage.vue';
import CuponsReportPage from '../reports/CuponsReportPage.vue';
import NotasReportPage from '../reports/NotasReportPage.vue';


const ckLoginAdmin= ref(false);
const isCollapsed = ref(false);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showAnalisesMenu = ref(false);
const showRelatoriosMenu = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;

const menuIcon = computed(() =>
  isCollapsed.value
    ? require('@/assets/icons/expand.svg')
    : require('@/assets/icons/compress.svg')
);

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value   = page;
    nmTitulo.value            = titulo;
    showAnalisesMenu.value      = false;
    showRelatoriosMenu.value  = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
    ckLoginAdmin.value = globalStore.ckadmin==='S';
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>

<style scoped src="@/assets/css/main.css"></style>
